"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lite_1 = __importDefault(require("mime/lite"));
var parseInputAccept = function (inputAccept) {
    var extensions = [];
    var mimeTypes = [];
    inputAccept
        .split(",")
        .map(function (mimeType) { return mimeType.trim(); })
        .filter(Boolean)
        .forEach(function (fileType) {
        if (fileType.startsWith(".")) {
            extensions.push("*".concat(fileType));
        }
        else {
            mimeTypes.push(fileType);
        }
    });
    return [extensions, mimeTypes];
};
var AcceptedFileTypes = /** @class */ (function () {
    function AcceptedFileTypes(inputAccept) {
        var _a = __read(parseInputAccept(inputAccept), 2), extensions = _a[0], mimeTypes = _a[1];
        this.extensions = extensions;
        this.mimeTypes = mimeTypes;
    }
    AcceptedFileTypes.prototype.isAccepted = function (fileName) {
        if (this.extensions.length === 0 && this.mimeTypes.length === 0) {
            return true;
        }
        return (this.isMimeTypeAccepted(lite_1.default.getType(fileName)) ||
            this.isExtensionAccepted(fileName));
    };
    AcceptedFileTypes.prototype.isMimeTypeAccepted = function (mimeType) {
        if (this.mimeTypes.length === 0) {
            return false;
        }
        return this.mimeTypes.includes(mimeType);
    };
    AcceptedFileTypes.prototype.isExtensionAccepted = function (fileName) {
        if (this.extensions.length === 0) {
            return false;
        }
        return this.extensions.includes(fileName.split(".").pop());
    };
    return AcceptedFileTypes;
}());
exports.default = AcceptedFileTypes;
